import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { CUSTOM_REPORT_REQUEST_ID_LIST } from './custom-report-constant';

class CustomReportServiceClass {
    getCustomReports = (params: HttpServiceParams) => {
        return HttpHelper.get({
            url: 'v1/merchant/company-admin/custom-reports',
            id: CUSTOM_REPORT_REQUEST_ID_LIST.GET_CUSTOM_REPORTS,
            config: { params: params.data },
        });
    };

    postCustomReport = (params: HttpServiceParams) => {
        return HttpHelper.post({
            url: 'v1/merchant/company-admin/custom-reports',
            data: params.data,
            id: CUSTOM_REPORT_REQUEST_ID_LIST.POST_CUSTOM_REPORT,
        });
    };

    downloadCustomReport = (params: HttpServiceParams) => {
        return HttpHelper.get({
            url: `v1/merchant/company-admin/custom-reports/documents/${params.data.requestId}`,
            id: CUSTOM_REPORT_REQUEST_ID_LIST.DOWNLOAD_CUSTOM_REPORT,
        });
    };
}

export const CustomReportService = new CustomReportServiceClass();
